module.exports = __webpack_public_path__ + "static/img/337_TO8_2599.2537f6a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/337_TO8_2599.jpg
// module id = spvw
// module chunks = 0